<template>
  <v-container fluid class="ma-0 pa-0">
    <v-layout>
    <v-flex>
      <v-img
        src="././img/tmp/bg1.webp"
        min-height="260"
        max-height="300"
        alt="Handwerker BG"
        dark
        lazy-src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAICAgICAgICAgIDAgICAwQDAgIDBAUEBAQEBAUGBQUFBQUFBgYHBwgHBwYJCQoKCQkMDAwMDAwMDAwMDAwMDAz/2wBDAQMDAwUEBQkGBgkNCgkKDQ8ODg4ODw8MDAwMDA8PDAwMDAwMDwwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAz/wAARCABUACYDAREAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAn/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAL/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdCwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB/9k="
      >
      <v-container>
        <v-layout>
          <h1 style="padding-top: 120px;" class="display-3 white--text">Alle Gewerke auf LokalesHandwerk.de</h1>
        </v-layout>
      </v-container>
 
      </v-img>
    </v-flex></v-layout>
    <v-container>
    <v-layout row wrap grid-list-lg v-if="this.gewerke">
      <div v-for="gewerk in this.gewerke" :key="gewerk.id">
          <div class="text-truncate">
            <v-btn large outline>
              <span class="subheading text-none font-weight-medium">{{ gewerk.name }}</span>
              </v-btn>
        </div>
      </div>
    </v-layout>
    </v-container>
  </v-container>
</template>
  

<script>
import axios from 'axios'
import LandingBetrieb from '~/components/startseite/VorgestellterBetrieb.vue'

export default {
  data: () => ({
    show: false,
    dialog: false,
    isLoading: false,
    betriebe: [],
    gewerke: []
  }),
  components: {
    LandingBetrieb
  },
  mounted () {
    this.getGewerke()
  },
  methods: {
    getGewerke: function () {
      this.isLoading = true
      const self = this
      axios.get('/api/v1/sitestats').then(response => {
        // console.log(response)
        self.gewerke = response.data.gewerke
        self.isLoading = false
      })
    .finally(() => {
      self.isLoading = false
    })
    }
  },
  filters: {
    truncate: function (text, length, suffix) {
      return text.substring(0, length) + suffix
    }
  }
}
</script>


<style>
</style>